<template>
  <div class="QuotationEditSuccess" v-title data-title="报价发布成功">
    <template v-if="datas && datas.length > 0">
      <div class="poster-box">
        <div class="fc-primary font-bold pt1 pb1">报价单海报</div>
        <van-image
          v-if="posterData"
          width="100%"
          fit="cover"
          :src="posterData"
        >
          <template v-slot:loading>
            图片加载中<van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <div v-else ref="poster-id" class="poster-content">
          <div v-for="(dataItem, dataItemindex) in datas" :key="dataItemindex" class="padding2 ">
            <Quotation @load="loadImage"
              :item="dataItem"
              :queryDateString="queryDateString"
              :pageType="$route.name === 'QuotationPosterTool'?'bill':'quotaion'"
              :template="tpl"
            ></Quotation>
          </div>
        </div>
        <div class="pt10">
          <div v-if="isWeixin && posterData" class="animation fc-primary font-bold">长按上方图片保存到手机、发送给朋友</div>
          <van-button v-else-if="!isWeixin" class="btn-common" type="info"
              @click="createImg">保存图片</van-button>
        </div>
        <div class="pt7">
          <van-button class="btn-common" type="info"
              @click="back">返回</van-button>
          </div>
      </div>
    </template>
    <div v-else-if="loading" class="pt10">请稍候,正在生成报价单...</div>
    <div v-else class="pt10">出错了</div>
    <!-- <div class="pt7">
      <van-button class="btn-success" type="primary"
          @click="send">发送给朋友</van-button>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import html2canvas from 'html2canvas';
import Quotation from '../../components/Quotation.vue';
import { sendRequest, getPosterData } from '../../network/NetworkAccessor';
import { isWeixin } from '../../uitls/checkUtil';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'QuotationEditSuccess',
  components: { Quotation },
  data() {
    function queryDateString() {
      let date = new Date();
      // 晚上七点以后发布的显示明天
      if (date.getHours() > 18) {
        date = new Date(date.getTime() + 1000 * 60 * 60 * 24);
      }
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${month}月${day}`;
    }
    return {
      info: {},
      datas: [],
      queryDateString: queryDateString(),
      posterData: '',
      isWeixin: isWeixin(),
      loading: false,
      loaded: false,
    };
  },
  props: {
    quoteType: {
      type: String,
      default: '1',
    },
    tpl: {
      type: String,
      default: '3',
    },
  },
  methods: {
    // 获取上次报价信息
    getLastData() {
      this.loading = true;
      sendRequest(getPosterData, { quoteType: this.quoteType }).then((res) => {
        this.datas = res.map((item) => {
          const quotes = JSON.parse(item.quotes || null) || [];
          let mobileList = [];
          try {
            mobileList = JSON.parse(item.mobile);
            if (Object.prototype.toString.call(mobileList) !== '[object Array]') {
              mobileList = [{
                mobile: item.mobile,
                name: '',
              }];
            }
          } catch (error) {
            console.error(error);
            mobileList = [{
              mobile: item.mobile,
              name: '',
            }];
          }
          return {
            ...item,
            quotes,
            mobileList,
          };
        });
      }).catch((e) => {
        console.error(e);
      }).then(() => {
        if (this.isWeixin) {
          setTimeout(() => {
            this.createImg();
          }, 1000);
        }
        this.loading = false;
      });
    },
    send() {
      console.log();
    },
    back() {
      if (this.$route.name === 'QuotationPosterTool') {
        this.$router.replace(`/quotation/posteredit/${this.tpl}`);
      } else {
        this.$router.replace(`/quotation/edit?quoteType=${this.quoteType}`);
      }
    },
    loadImage(flag) {
      this.loaded = true;
      if (this.isWeixin) {
        this.createImg();
      }
    },
    createImg() {
      this.$nextTick().then(() => {
        // const windowWidth = window.document.body.scrollWidth;
        // const windowHeight = window.document.body.scrollHeight;
        // const windowScreenWidth = window.screen.width;
        const html2canvasOptions = {
          allowTaint: true,
          useCORS: false,
          scrollX: 0,
          scrollY: 0,
          // windowWidth,
          // windowHeight,
          dpi: window.devicePixelRatio * 2, // 解决图片不清晰问题
          scale: 2,
        };
        // if (windowScreenWidth > windowWidth) {
        //   delete html2canvasOptions.windowWidth;
        //   delete html2canvasOptions.windowHeight;
        // }
        // console.log('html2canvasOptions: ', html2canvasOptions);
        html2canvas(this.$refs['poster-id'], html2canvasOptions).then((canvas) => {
          if (this.isWeixin) {
            const dataUrl = canvas.toDataURL();
            this.posterData = dataUrl;
            return;
          }
          const { userAgent } = navigator;
          // 判断是否是IE11
          if (userAgent.indexOf('Trident') !== -1) {
            const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
            const arr = image.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n) {
              n -= 1;
              u8arr[n] = bstr.charCodeAt(n);
            }
            window.navigator.msSaveBlob(new Blob([u8arr], { type: mime }), `报价单海报_${this.queryDateString}.png`);
          } else {
            // 生成base64图片数据
            const dataUrl = canvas.toDataURL();
            // this.posterData = dataUrl;
            const newImg = document.createElement('img');
            newImg.src = dataUrl;
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = dataUrl;
            // 获取文件名
            // download 属性定义了下载链接的地址而不是跳转路径
            link.setAttribute('download', `报价单海报_${this.queryDateString}.png`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        }).catch((e) => {
          console.error(e);
        });
      });
    },
  },
  created() {
    if (this.$route.name === 'QuotationPosterTool') {
      this.loading = true;
      this.info = storage.session.get('POSTER_DATA');
      if (!this.info) {
        this.$router.replace('/quotation/template');
        return;
      }
      this.queryDateString = this.info.queryDateText;
      if (this.isWeixin) {
        setTimeout(() => {
          this.createImg();
          this.loading = false;
        }, 1000);
      }
    } else {
      this.getLastData();
    }
  },
});
</script>
<style scoped>
.QuotationEditSuccess {
  min-height: 100vh;
}
.btn-success {
  width: 60%;
}
.poster-box {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100vh;
}
.poster-content {
  border: 12px solid #f44;
  border-radius: 4px;
}
.QuotationEditSuccess .animation {
  animation: dd 5s .15s linear infinite;
}
@keyframes dd {
  0%,
  100% {
  -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
  -webkit-transform-origin: 50% 0;
          transform-origin: 50% 0;
  }
  5% {
  -webkit-transform: rotate(2deg);
          transform: rotate(2deg);
  }
  10%,
  20%,
  30% {
  -webkit-transform: rotate(-4deg);
          transform: rotate(-4deg);
  }
  15%,
  25%,
  35% {
  -webkit-transform: rotate(4deg);
          transform: rotate(4deg);
  }
  40% {
  -webkit-transform: rotate(-2deg);
          transform: rotate(-2deg);
  }
  45% {
  -webkit-transform: rotate(2deg);
          transform: rotate(2deg);
  }
  50% {
  -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
  }
}
</style>
